module.exports = __webpack_public_path__ + "img/whatsapp.3f7641a.svg";